var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 76,
    viewBox: "0 0 71 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 71,
    height: 76,
    rx: 20,
    fill: "#EFF9FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.5 16C23.645 16 14 25.645 14 37.5C14 49.355 23.645 59 35.5 59C47.355 59 57 49.355 57 37.5C57 25.645 47.355 16 35.5 16ZM38.8077 47.4231H32.1923C31.7537 47.4231 31.333 47.2488 31.0229 46.9387C30.7127 46.6285 30.5385 46.2079 30.5385 45.7692C30.5385 45.3306 30.7127 44.9099 31.0229 44.5998C31.333 44.2896 31.7537 44.1154 32.1923 44.1154H38.8077C39.2463 44.1154 39.667 44.2896 39.9771 44.5998C40.2873 44.9099 40.4615 45.3306 40.4615 45.7692C40.4615 46.2079 40.2873 46.6285 39.9771 46.9387C39.667 47.2488 39.2463 47.4231 38.8077 47.4231ZM43.7692 40.8077H27.2308C26.7921 40.8077 26.3715 40.6334 26.0613 40.3233C25.7512 40.0131 25.5769 39.5925 25.5769 39.1538C25.5769 38.7152 25.7512 38.2946 26.0613 37.9844C26.3715 37.6742 26.7921 37.5 27.2308 37.5H43.7692C44.2079 37.5 44.6285 37.6742 44.9387 37.9844C45.2488 38.2946 45.4231 38.7152 45.4231 39.1538C45.4231 39.5925 45.2488 40.0131 44.9387 40.3233C44.6285 40.6334 44.2079 40.8077 43.7692 40.8077ZM47.0769 34.1923H23.9231C23.4844 34.1923 23.0638 34.0181 22.7536 33.7079C22.4435 33.3978 22.2692 32.9771 22.2692 32.5385C22.2692 32.0998 22.4435 31.6792 22.7536 31.369C23.0638 31.0589 23.4844 30.8846 23.9231 30.8846H47.0769C47.5156 30.8846 47.9362 31.0589 48.2464 31.369C48.5565 31.6792 48.7308 32.0998 48.7308 32.5385C48.7308 32.9771 48.5565 33.3978 48.2464 33.7079C47.9362 34.0181 47.5156 34.1923 47.0769 34.1923Z",
    fill: "#21A6E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.716dac0c5e2d655ca2073d6ad270a437.svg";
export { ForwardRef as ReactComponent };